import { MappedClass, MappedPropertyClass } from '@h5s/util-object';
import { ZPrinterBooleanApplicable } from './z-printer-boolean-applicable';
import { ZPrinterStringApplicable } from './z-printer-string-applicable';
import { ZPrinterStringListApplicable } from './z-printer-string-list-applicable';
import { ZPrinterFiscalConfigDepartmentListApplicable } from './z-printer-fiscal-config-department-list-applicable';
import { ZPrinterFiscalConfigPaymentListApplicable } from './z-printer-fiscal-config-payment-list-applicable';
import { ZPrinterFiscalConfigVatListApplicable } from './z-printer-fiscal-config-vat-list-applicable';
import { ZPrinterInt32Applicable } from './z-printer-int32-applicable';

@MappedClass()
export class ZPrinterFiscalConfig {
  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  print_exempted_products: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterStringApplicable)
  first_courtesy_line: ZPrinterStringApplicable;

  @MappedPropertyClass(() => ZPrinterStringApplicable)
  second_courtesy_line: ZPrinterStringApplicable;

  @MappedPropertyClass(() => ZPrinterStringListApplicable)
  headings: ZPrinterStringListApplicable;

  @MappedPropertyClass(() => ZPrinterStringApplicable)
  main_logo: ZPrinterStringApplicable;

  @MappedPropertyClass(() => ZPrinterStringApplicable)
  secondary_logo: ZPrinterStringApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  department_net: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  midnight_alert: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  print_operator: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  print_device_number: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  single_quantity: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  print_unit_price: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  show_change: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  show_single_quantity: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterStringApplicable)
  sliding_message: ZPrinterStringApplicable;

  @MappedPropertyClass(() => ZPrinterFiscalConfigPaymentListApplicable)
  payments: ZPrinterFiscalConfigPaymentListApplicable;

  @MappedPropertyClass(() => ZPrinterFiscalConfigDepartmentListApplicable)
  departments: ZPrinterFiscalConfigDepartmentListApplicable;

  @MappedPropertyClass(() => ZPrinterFiscalConfigVatListApplicable)
  vats: ZPrinterFiscalConfigVatListApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  show_sliding_message: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterInt32Applicable)
  sliding_message_timeout: ZPrinterInt32Applicable;

  @MappedPropertyClass(() => ZPrinterInt32Applicable)
  drawer_pulse: ZPrinterInt32Applicable;

  @MappedPropertyClass(() => ZPrinterInt32Applicable)
  receipt_limit: ZPrinterInt32Applicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  appendix_cut: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  vat_ventilation: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  print_buffer: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  is_fidelity_enabled: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  is_cutter_enabled: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  auto_open_drawer: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  print_header_on_reports: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  print_x_before_z_report: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  print_transmission_report: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterInt32Applicable)
  header_logo_index: ZPrinterInt32Applicable;

  @MappedPropertyClass(() => ZPrinterInt32Applicable)
  footer_logo_index: ZPrinterInt32Applicable;

  @MappedPropertyClass(() => ZPrinterInt32Applicable)
  register_number: ZPrinterInt32Applicable;

  @MappedPropertyClass(() => ZPrinterInt32Applicable)
  logo_alignment: ZPrinterInt32Applicable;

  @MappedPropertyClass(() => ZPrinterInt32Applicable)
  rt_transmission_retry_minutes: ZPrinterInt32Applicable;

  @MappedPropertyClass(() => ZPrinterInt32Applicable)
  rounding_mode: ZPrinterInt32Applicable;

  @MappedPropertyClass(() => ZPrinterInt32Applicable)
  communication_pc: ZPrinterInt32Applicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  lottery: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  ssn_service: ZPrinterBooleanApplicable;
}
